import {
  IFSecureOrchestrator,
  IFsecureReactivationOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { IServiceStatus } from "@nju/data-access-portal-product";

interface IProps {
  orchestrator?: IFSecureOrchestrator | undefined;
  serviceStatus: IServiceStatus["fSecureServiceStatus"];
  reactivationOrchestratorStatus:
    | IFsecureReactivationOrchestrator["state"]
    | undefined;
}

export function getFSecureServiceCTABannerConditions({
  orchestrator,
  serviceStatus,
  reactivationOrchestratorStatus,
}: IProps) {
  return {
    isPendingTermination:
      orchestrator?.state === "COMPLETED" &&
      serviceStatus === "PendingTermination",
    isSuspended:
      orchestrator?.state === "COMPLETED" &&
      (reactivationOrchestratorStatus === undefined ||
        reactivationOrchestratorStatus === "START") &&
      serviceStatus === "Suspended",
    isPendingReactivation:
      orchestrator?.state === "COMPLETED" &&
      !!reactivationOrchestratorStatus &&
      reactivationOrchestratorStatus !== "START" &&
      (serviceStatus === "Suspended" || serviceStatus === "Disconnected"),
  };
}
